export const ROLE_CASSADIGITALE = "User_CassaDigitale"
export const ROLE_FUTURO = "UserPlatform_Futuro"
export const ROLE_MEDIATORI = "User_PiattaformaMediatori"
